import { auctionTypes, Bidding_Through, buyNowAuctionTimeInMins, carApprovalStatus, exportAuctionTimeInMins, localAuction, localAuctionTimeInMins } from "../constants/auction";
import { CAR_STATUS } from "../constants/carData";
import { convertFromUTCToGivenTimezone, convertToUTCFormat, convertUtcStringFormat } from "../methods/dateTime";
import { setCarEstimateVehicleId, setImages } from '../../toolkit/carEstimate/carEstimateSlice';
import { routes } from "../constants/routes";
import { feeConfig } from "../constants/fees";

const isVehicleEditButtonEnabled = ({
  car
}) => {
  const isAdminApproved = car?.Admin_Approval_Status;
  const isAdminBuyNowApproved = car?.Admin_Approval_Status_BuyNow;
  const isAgentApproved = car?.Agent_Approval_Status;
  const isAgentBuyNowApproved = car?.Agent_Approval_Status_BuyNow;

  // return true;
  return (!isAdminApproved && !isAgentApproved && !isAdminBuyNowApproved && !isAgentBuyNowApproved) || (car?.car_label_status === CAR_STATUS.RELIST_PENDING) || (car?.car_label_status === CAR_STATUS.UNSOLD_CAR);
}

const isVehicleDataEditEnabled = ({
  car
}) => {

  const isAdminApproved = car?.Admin_Approval_Status;
  const isAdminBuyNowApproved = car?.Admin_Approval_Status_BuyNow;
  const isAgentApproved = car?.Agent_Approval_Status;
  const isAgentBuyNowApproved = car?.Agent_Approval_Status_BuyNow;

  // return true;
  return ((!isAdminApproved && !isAgentApproved && !isAdminBuyNowApproved && !isAgentBuyNowApproved) || (car?.car_label_status === CAR_STATUS.RELIST_PENDING)) || (car?.car_label_status === CAR_STATUS.UNSOLD_CAR);
}

const isVehicleSold = ({
  car
}) => {
  return (car?.Sold_Out === 1);
};

const getLiveAuctionEndDateTimeInUTC = ({
  liveAuctionDateTime
}) => {
  const utcDateString = convertUtcStringFormat(liveAuctionDateTime);
  return utcDateString;
}

const xSecondsBeforeOrAfterAuctionTime = ({
  auctionTime,
  totalSeconds,
  beforeOrAfter,
  liveAuctionOrBuyNow,
  auctionType
}) => {
  const utcDateString = convertUtcStringFormat(auctionTime);
  const currentDate = new Date();
  const date = new Date(utcDateString);


  if (beforeOrAfter === "before") {
    date.setSeconds(date.getSeconds() - totalSeconds);
    return currentDate <= date;
  } else {
    date.setSeconds(date.getSeconds() +
      (liveAuctionOrBuyNow === auctionTypes.liveAuction ?
        ((auctionType === localAuction ? localAuctionTimeInMins : exportAuctionTimeInMins) * 60) :
        (buyNowAuctionTimeInMins * 60)) +
      totalSeconds);
    return currentDate >= date;
  }
};

const xSecondsBeforeOrAfterSoldOutDateTime = ({
  soldOutDateTime,
  totalSeconds,
  beforeOrAfter,
}) => {
  const utcDateString = convertUtcStringFormat(soldOutDateTime);
  const currentDate = new Date();
  const date = new Date(utcDateString);


  if (beforeOrAfter === "before") {
    date.setSeconds(date.getSeconds() - totalSeconds);
    return currentDate <= date;
  } else {
    date.setSeconds(date.getSeconds() + totalSeconds);
    return currentDate >= date;
  }
};

const getBidHistoryHandler = ({
  auctionType,
  getBidHistoryApiData
}) => {
  const bidHistory = getBidHistoryApiData?.data?.TopBids
    ?.filter?.(bid => {
      if (auctionType === Bidding_Through.Auction) {
        return (bid?.Bidding_Through === Bidding_Through.Auction);
      } else {
        return (bid?.Bidding_Through === Bidding_Through.BuyNow);
      }
    })
    ?.map?.(bid => {
      return {
        ...bid,
        amount: bid?.Bid_Amount,
        dealerId: bid?.Dealer_Id,
        dateTime: bid?.Bid_Date
      }
    });

  return bidHistory;
}

const hasLiveAuctionStarted = (car) => {
  let liveAuctionDateTime;

  liveAuctionDateTime = convertUtcStringFormat(car?.Live_Auction_DateTime);

  const liveAuctionDate = new Date(liveAuctionDateTime);

  return new Date() >= liveAuctionDate;
};

const setupAndNavigateToCarEstimateHandler = ({
  car,
  dispatch,
  navigate,
  images = {}
}) => {
  console.log(`onSuccessCallback`, car);
  // if (myGarage?.isEditing) {
  //   setPageTab(pageTabs?.view);
  //   dispatch(resetMyGarageSlice());
  // } else {
  dispatch(setCarEstimateVehicleId(car?.Vehicle_Id));

  let imgs = []
  for (let item in images) {
    imgs.push(...(images?.[item] || []));
  }

  dispatch(setImages(imgs?.filter((item) => item)));
  navigate(`${routes.dashboardNavigation}${routes.carEstimate}`);
  // setPageTab(pageTabs.view);
  // }
};


/**
 * Calculates the fee (buyer or seller) based on the winning amount.
 * @param {number} winningAmount The vehicle sale price.
 * @param {string} feeType 'buyer' or 'seller'.
 * @returns {number} The calculated fee amount.
 */
function getCalculatedFee(winningAmount, feeTiers) {
  if (!feeTiers || typeof winningAmount !== 'number' || winningAmount < 0) {
    return 0;
  }

  for (const range of feeTiers) {
    const isMinMet = winningAmount >= range.min;

    // Correctly handles the 'max: null' for the final (percentage) tier.
    const isMaxMet = range.max === null || winningAmount <= range.max;

    if (isMinMet && isMaxMet) {

      // 1. Check for percentage fee (high-value sales)
      if (range.fee_percent !== undefined) {
        return winningAmount * (range.fee_percent / 100);
      }

      // 2. Otherwise, use the fixed fee
      else if (range.fee !== undefined) {
        return range.fee;
      }
    }
  }

  return 0;
};

export function calculateBuyerFee(winningAmount) {
  const buyerTiers = feeConfig.buyer;
  return getCalculatedFee(winningAmount, buyerTiers);
}

export function calculateSellerFee(winningAmount) {
  const sellerTiers = feeConfig.seller;
  return getCalculatedFee(winningAmount, sellerTiers);
}

function getCategoryFromUrl(url) {
  const filename = url.split("/").pop();
  const category = filename.split("_")[0];      // interior
  return category;
}

const calculateTaxForCostBreakdown = (
  vehiclePurchasePrice,
  buyerFee,
  serviceFee
) => {
  const tax = (feeConfig.tax_rate / 100) * (vehiclePurchasePrice + buyerFee + serviceFee);
  return tax;
};

const getUpcomingCarRemainingSeconds = (car, liveAuctionOrBuyNow, auth) => {
  let auctionStartDateTime, auctionStartDate, auctionRemainingSeconds;

  if (liveAuctionOrBuyNow === auctionTypes.liveAuction && !car?.Live_Auction_DateTime) {
    return 0;
  } else if (liveAuctionOrBuyNow === auctionTypes.buyNow && !car?.Buy_now_DateTime) {
    return 0;
  }

  auctionStartDateTime = convertFromUTCToGivenTimezone({
    dateStr: convertUtcStringFormat(liveAuctionOrBuyNow === auctionTypes.liveAuction ? car?.Live_Auction_DateTime : car?.Buy_now_DateTime),
    timezone: auth?.timezone,
  });

  auctionStartDate = new Date(auctionStartDateTime);

  if (liveAuctionOrBuyNow === auctionTypes.buyNow) {
    auctionStartDate.setDate(auctionStartDate.getDate() - 1);
  }

  const currentDate = new Date();

  auctionRemainingSeconds = (auctionStartDate.getTime() - currentDate.getTime()) / 1000;

  return auctionRemainingSeconds;
};

export {
  isVehicleDataEditEnabled,
  isVehicleEditButtonEnabled,
  isVehicleSold,
  getLiveAuctionEndDateTimeInUTC,
  xSecondsBeforeOrAfterAuctionTime,
  xSecondsBeforeOrAfterSoldOutDateTime,
  getBidHistoryHandler,
  hasLiveAuctionStarted,
  setupAndNavigateToCarEstimateHandler,
  getCategoryFromUrl,
  calculateTaxForCostBreakdown,
  getUpcomingCarRemainingSeconds
};